import { Dropdown as AntDropdown, DropdownProps } from "antd";

export const Dropdown: React.FC<React.PropsWithChildren<DropdownProps>> = (
  props: DropdownProps
) => {
  return <AntDropdown trigger={["click"]} {...props} />;
};
